import React, { useEffect, useRef } from 'react';
import { WithPortal } from '../../src/hocs/withPortal';

import { ModalWrap } from '@nebo-team/vobaza.ui.modals.modal-wrap/dist';

export interface IModalLayoutProps {
  active: boolean;
  className?: string;
  onClose(value: boolean): void;
}

export const ModalLayout = ({
  className = '',
  children,
  active,
  onClose,
}: IModalLayoutProps & { children: React.ReactNode }) => {
  const modalRef = useRef(null);

  // useClickOutside(modalRef, () => {
  //   if (active) onClose(false);
  // });

  useEffect(() => {
    document.body.style.overflow = active ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = '';
    };
  }, [active]);

  return (
    <>
      {active ? (
        <WithPortal>
          <div className={`modal-layout ${className}`}>
            <ModalWrap ref={modalRef} onClose={() => onClose(false)}>
              {children}
            </ModalWrap>
          </div>
        </WithPortal>
      ) : null}

      <style jsx>{`
        .modal-layout {
          width: 100vw;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          background: rgba(33, 33, 33, 0.7);
          z-index: 99;
          overflow-y: auto;
          overflow-x: hidden;
        }
      `}</style>
    </>
  );
};
